import { render, staticRenderFns } from "./usg.vue?vue&type=template&id=f84e01cc&scoped=true"
import script from "./usg.vue?vue&type=script&lang=js"
export * from "./usg.vue?vue&type=script&lang=js"
import style0 from "./usg.vue?vue&type=style&index=0&id=f84e01cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84e01cc",
  null
  
)

export default component.exports